import { DashboardEndpoint, DashboardEndpointRoutes } from './dashboard.interface';


export class DashboardEndpointFactory 
{
	public static build(baseUrl: string): DashboardEndpoint 
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): DashboardEndpointRoutes 
	{
		return {
			dashboard: {
				toString: () => `${baseUrl}v0/api`,
				
				getNumberOfUnitsData: {
					toString: () => 'v0/dashboard/widget/number-units'
				},
				getFinancedEquipmentData: {
					toString: () => 'v0/dashboard/widget/financed-equipment-count'
				},
				getAverageAgeEquipmentData: {
					toString: () => 'v0/dashboard/widget/average-age-equipment'
				},
				getNewEquipmentOrders: {
					toString: () => 'v0/dashboard/widget/equipment-count-status'
				}
				
			}
		} as DashboardEndpointRoutes;
	}
}
